import { IntlShape } from 'react-intl';
import { SidebarFooterActionsOrder } from '../sidebar-footer/sidebar-footer-actions/utils';

export const sidebarAdditionalInfoTypes = [
  'sidebarAdditionalInfo.fieldIds',
  'sidebarAdditionalInfo.confidenceScores',
  'sidebarAdditionalInfo.hiddenFieldsVisible',
  'sidebarAdditionalInfo.automationBlockers',
] as const;

export const sidebarNavigationOptions = [
  'sidebarNavigation.stay',
  'sidebarNavigation.next',
  'sidebarNavigation.leave',
] as const;

export const annotationMethodTypes = [
  'annotationMethod.suggestions',
  'annotationMethod.gridDesign',
] as const;

export const showSuggestionsTypes = [
  'showSuggestions.automatically',
  'showSuggestions.onDemand',
] as const;

export const annotationValidationTypes = [
  'annotationValidation.automatically',
  'annotationValidation.onDemand',
] as const;

export const sortFooterColumnsTypes = [
  'sortColumns.automatically',
  'sortColumns.queueSettings',
] as const;

export const footerLayoutTypes = [
  'footerLayout.table-per-page',
  'footerLayout.one-table',
] as const;

export type ValueType = (
  | typeof sidebarAdditionalInfoTypes
  | typeof annotationMethodTypes
  | typeof showSuggestionsTypes
  | typeof annotationValidationTypes
  | typeof sortFooterColumnsTypes
  | typeof footerLayoutTypes
)[number];

export type FormValues = {
  additionalInfo?: Array<(typeof sidebarAdditionalInfoTypes)[number]>;
  navigation: (typeof sidebarNavigationOptions)[number];
  actionsOrder: SidebarFooterActionsOrder;
  annotationMethod: (typeof annotationMethodTypes)[number];
  showSuggestions: (typeof showSuggestionsTypes)[number];
  annotationValidation: (typeof annotationValidationTypes)[number];
  sortFooterColumns: (typeof sortFooterColumnsTypes)[number];
  footerLayout: (typeof footerLayoutTypes)[number];
};

export const getOption = <T extends ValueType>(intl: IntlShape, value: T) => ({
  title: intl.formatMessage({
    id: `components.lineItemsSettings.${value}.title`,
  }),
  description: intl.formatMessage({
    id: `components.lineItemsSettings.${value}.description`,
  }),
  value,
});
